import "ngstorage";

import {WALKTHROUGH_STATES, TRIGGER_NEXT_EVENT_NAME} from "../../variables";

class HiringmanagerController {
  constructor(
    $localStorage,
    $rootScope,
    $state,
    $stateParams,
    AuthService,
    EnvService,
    SecurityService,
    $timeout,
    TrackingService,
    events,
    companies
  ) {
    this.name = "hiringmanager";
    this.walkthroughState = WALKTHROUGH_STATES.HIRE;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;
    this.$companies = companies;

    this.API_FIELDS = "subEvents.deduppedJobbles.id, subEvents.deduppedJobbles.manager.id";

    this.managers = this.$rootScope.hiring_managers;
  }

  $onInit() {
    this.event.hiring_manager = this.event.hiring_manager + "";
    this.syncWithApi();
    this.getCompanyUsers();
  }

  syncWithApi() {
    this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then((data) => {
      this.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
      const manager = data.data.subEvents[0].deduppedJobbles[0].manager.id;
      this.event.hiring_manager = manager + "";
    });
  }

  getCompanyUsers(manager) {
    this.$companies.getCompanyUsers().then(
      (response) => {
        this.constructOptions(response.data, manager);
      },
      (error) => {}
    );
  }

  constructOptions(users) {
    let user_array = [];

    users.forEach((user) => {
      let user_map = {};

      if (user.homeContactInfo.phoneMobile) {
        user_map.firstName = user.firstName;
        user_map.lastName = user.firstName;
        user_map.phone = user.homeContactInfo.phoneMobile;
        user_map.id = user.id;
        user_map.str = user.firstName + " " + user.lastName;
        user_map.email = user.email;
        user_array.push(user_map);
      } else {
        user.homeContactInfo.phoneMobile = "--";
        user_map.firstName = user.firstName;
        user_map.lastName = user.firstName;
        user_map.phone = user.homeContactInfo.phoneMobile;
        user_map.id = user.id;
        user_map.str = user.firstName + " " + user.lastName;
        user_map.email = user.email;
        user_array.push(user_map);
      }
    });

    this.managers = user_array;
  }

  updateHiringManager() {
    this.$timeout(() => {
      this.savingStep = true;
    });

    this.$events.saveEventHiringManager(this.jobble_id, this.event.hiring_manager).then((data) => {
      this.$timeout(() => {
        this.savingStep = false;
      });
      console.log("Saved hiring manager:", data);
    });
  }

  goNext() {
    this.$tracking.reportPostAJobSubmitStep("hiring manager");
    this.$rootScope.$emit(TRIGGER_NEXT_EVENT_NAME, {
      walkthroughState: this.walkthroughState,
    });
  }
}

HiringmanagerController.$inject = [
  "$localStorage",
  "$rootScope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
  "companies",
];

export default HiringmanagerController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/hiringmanager/hiringmanager.controller.js